import { useForm } from 'react-hook-form';
import iconClose from '../assets/icon/icon_close.svg';
import logoKalpanax from '../assets/image/logo_kalpanax.png';
import Button from './button';
import Footer from './footer';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CONFIG from '../config/apiConfig';
import { useContext, useEffect, useState } from 'react';
import { ProfileContext } from './context/profileContext';
import Cookies from 'js-cookie';

const FormLogin = (props) => {
  const [msgError, setMsgError] = useState('');
  const { setProfile } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    control,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm({
    defaultValues: {
      question: [{ question: '' }] // Start with one empty question field
    }
  });

  const onSubmit = async (data) => {
    setLoading(true);
    setMsgError('');
    const payload = { email: data.email, password: data.password };

    try {
      const response = await axios.post(CONFIG.API_URL + '/login', payload);
      if (response?.data?.message === 'success') {
        Cookies.set('auth_token', response.data.data.token, {secure: true});

        const profileResponse = await axios.get(CONFIG.API_URL + '/profile', {
          headers: { Authorization: `Bearer ${response.data.data.token}` }
        });

        if (profileResponse?.data?.message === 'success') {
          setProfile(profileResponse.data.data);
          setLoading(false);
          navigate('/profile');
        } else {
          setLoading(false);
          setMsgError('Login error: Ada kesalahan pada sistem, silahkan coba lagi.');
        }
      } else {
        setLoading(false);
        setMsgError('Login error: Ada kesalahan pada sistem, silahkan coba lagi.');
        return false;
      }
    } catch (error) {
      setLoading(false);
      setMsgError('Login error: ' + error.response.data.message);
      return false;
    }
  };

  return (
    <div className="flex flex-col z-20 fixed md:absolute top-0 md:top-20 right-0 md:right-5 w-screen md:w-96 h-screen md:h-max bg-gradient-to-b from-lightCream to-cream">
      <div className="p-4 md:p-0 h-full">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-col justify-start items-start p-8 border border-gray-100 bg-white h-full md:h-max shadow-md rounded-xl">
          <div className="flex md:hidden  flex-col justify-center items-center w-full ">
            <div className="flex justify-end items-center w-full">
              <img
                onClick={() => props.onClose()}
                src={iconClose}
                className="cursor-pointer w-8 h-8 object-contain"
                alt="icon_close"
              />
            </div>

            <div className="flex flex-col justify-center items-center my-12 w-full">
              <img
                src={logoKalpanax}
                className="cursor-pointer w-1/2 object-contain "
                alt="logo kalpanax"
              />
              <label
                htmlFor="firstname"
                className="block text-base font-normal text-textGray mt-2">
                Skin Check
              </label>
            </div>
          </div>

          <div className="flex justify-between items-center w-full">
            <span className="text-red font-bold text-2xl">Selamat Datang</span>
            <img
              onClick={() => props.onClose()}
              src={iconClose}
              className="hidden md:block cursor-pointer w-8 h-8 object-contain"
              alt="icon_close"
            />
          </div>

          <div className="w-full flex flex-col space-y-5 mt-5 mb-5">
            <div className="w-full">
              <label
                htmlFor="firstname"
                className="block text-base font-semibold text-textGray">
                Email
              </label>
              <input
                id="email"
                name="email"
                type="email"
                placeholder="Masukkan email anda"
                {...register('email', {
                  required: 'Email Harus diisi'
                })}
                className={`mt-1 block w-full p-2 border ${
                  errors.email ? 'border-red' : 'border-textGray'
                } rounded-md shadow-sm focus:border-textGray focus-within:border-textGray`}
              />
              {errors.email && (
                <p className="text-red-500 text-xs mt-1 text-red">
                  {errors.email.message}
                </p>
              )}
            </div>

            <div className="w-full">
              <label
                htmlFor="password"
                className="block text-base font-semibold text-textGray">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                placeholder="Masukkan password anda"
                {...register('password', {
                  required: 'Password Harus diisi'
                })}
                className={`mt-1 block w-full p-2 border ${
                  errors.password ? 'border-red' : 'border-textGray'
                } rounded-md shadow-sm focus:border-textGray focus-within:border-textGray`}
              />
              {errors.password && (
                <p className="text-red-500 text-xs mt-1 text-red">
                  {errors.password.message}
                </p>
              )}
            </div>
          </div>

          {/* <div
            onClick={() => alert('clicked')}
            className="mt-2 cursor-pointer text-textGray text-sm flex w-full justify-end items-center mb-5">
            Lupa password
          </div> */}

          {msgError !== '' && (
            <div>
              <p className="text-red-500 text-xs mb-2 text-red font-semibold text-center">
                {msgError}
              </p>
            </div>
          )}

          <Button
            bold
            loading={loading}
            type="submit"
            label="Masuk"
            onClick={() => props.onClose()}
          />
        </form>
      </div>

      <div className="block md:hidden">
        <Footer />
      </div>
    </div>
  );
};

export default FormLogin;
